var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`value-currency ${_vm.styleClass ? _vm.styleClass : ''}`,style:('display: ' + _vm.display)},[_vm._v(_vm._s(_vm.showingValue)),_c('span',{staticClass:"value-currency__sign"},[_vm._v(_vm._s(_vm.showingSign))])])
}
var staticRenderFns = []

export { render, staticRenderFns }